import React from 'react';
import { useHasQuestions, useQuestions, worksheetActions } from '@src/stores/worksheet.store';
import Layout from '../Maker.layout';
import * as styles from '../maker.module.css';

const Selections = () => {
  const questions = useQuestions();
  const hasQuestions = useHasQuestions();

  const removeQuestion = (id: string) => {
    worksheetActions.removeQuestion(id);
  };

  if (!hasQuestions) {
    return (
      <Layout>
        <p>Select questions from the question bank to create a worksheet.</p>
      </Layout>
    );
  }
  return (
    <Layout>
      {questions.map((question) => (
        <button
          key={question.slug}
          className={styles.question}
          onClick={() => removeQuestion(question.slug)}
        >
          <p>{question.title}</p>
        </button>
      ))}
    </Layout>
  );
};

export default Selections;
